<template>
    <div class="release">
        <div class="wx_title"><span>XXXX巡园任务</span></div>
        <table class="my_table">
            <thead>
            <tr>
                <th width="170">执行任务时间:</th>
                <th width="210" class="th_background time">
                    <el-date-picker
                            class="fl"
                            v-model="time_val"
                            v-if="timeEdit"
                            type="date"
                            size="mini"
                            format="yyyy.MM.dd"
                            value-format="yyyy.MM.dd"
                            @change='timeValChane'
                            placeholder="选择日期">
                    </el-date-picker>
                    <span class="time_val fl" v-else>{{time_val}}</span>
                    <span class="tab_btn fl" @click="timeEdit=true">重新编辑</span>
                </th>
                <th width="170">任务执行分区:</th>
                <th width="100" class="th_background">A区</th>
                <th width="170">任务作物大类:</th>
                <th class="th_background">柑橘、枇杷</th>
                <th width="140">任务类别:</th>
                <th width="130" class="th_background">{{type}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td colspan="2">执行操作说明</td>
                <td colspan="5">
                    <el-input v-if="textareaShow" type="textarea" :autosize="{ minRows: 4}" v-model="explain"></el-input>
                    <span v-else>{{textareaSpanVal}}</span>
                </td>
                <td class="tab_btns">
                    <el-button class="edit_btn" type="primary" plain size="small" @click="textareaShow = true">编辑</el-button>
                    <el-button class="detail_btn" type="success" plain size="small" @click="saveTextareaSpanVal">保存</el-button>
                    <el-button class="del_btn" type="danger" plain size="small" @click="textareaShow = false">取消</el-button>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="tdBack1">任务操作文档</td>
                <td colspan="6" class="tdBack2">XXXX.pdf</td>
            </tr>
            <template v-if="type == '巡园类'">
                <tr>
                    <td rowspan="4" colspan="2">任务内容</td>
                    <td colspan="6">观察植株物候期</td>
                </tr>
                <tr>
                    <td colspan="6">观察植株部位情况：根、茎、叶、花、果</td>
                </tr>
                <tr>
                    <td colspan="6">观察病虫害情况</td>
                </tr>
                <tr>
                    <td colspan="6">观察土壤湿度</td>
                </tr>
            </template>
            <template v-if="type == '打药类'">
                <tr>
                    <td rowspan="6" colspan="2">任务内容</td>
                    <td colspan="6">针对病虫害为：XXXXX,XXXXXX，您的农资有：</td>
                </tr>
                <tr>
                    <td>农资种类</td>
                    <td>农资名</td>
                    <td>稀释比例</td>
                    <td>每亩用量</td>
                    <td>剩余量</td>
                    <td width="130">操作</td>
                </tr>
                <tr>
                    <td>农资</td>
                    <td>XX肥料</td>
                    <td>稀释比例为:24</td>
                    <td>1KG</td>
                    <td>34KG</td>
                    <td class="tab_btns">
                        <el-button class="edit_btn" type="primary" plain size="small" @click="addShow = true">编辑</el-button>
                        <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>
                    </td>
                </tr>
                <tr>
                    <td>激素</td>
                    <td>XX肥料</td>
                    <td>稀释比例为:24</td>
                    <td>1KG</td>
                    <td>34KG</td>
                    <td class="tab_btns">
                        <el-button class="edit_btn" type="primary" plain size="small" @click="addShow = true">编辑</el-button>
                        <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>
                    </td>
                </tr>
                <tr>
                    <td>耗材</td>
                    <td>XX肥料</td>
                    <td>稀释比例为:24</td>
                    <td>1KG</td>
                    <td>34KG</td>
                    <td class="tab_btns">
                        <el-button class="edit_btn" type="primary" plain size="small" @click="addShow = true">编辑</el-button>
                        <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>
                    </td>
                </tr>
                <tr>
                    <td colspan="6" class="addBtn">
                        <el-button class="edit_btn" type="primary" plain size="small">添加农资</el-button>
                    </td>
                </tr>
            </template>
            <template v-if="type == '营养管理类'">
                <tr>
                    <td rowspan="5" colspan="2">任务内容</td>
                </tr>
                <tr>
                    <td>肥料名</td>
                    <td colspan="2">稀释比例</td>
                    <td>每亩用量</td>
                    <td>剩余量</td>
                    <td width="130">操作</td>
                </tr>
                <tr>
                    <td>XX肥料</td>
                    <td colspan="2">稀释比例为:30</td>
                    <td>1KG</td>
                    <td>34KG</td>
                    <td class="tab_btns">
                        <el-button class="edit_btn" type="primary" plain size="small" @click="editShow = true">编辑</el-button>
                        <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>
                    </td>
                </tr>
                <tr>
                    <td>XX肥料</td>
                    <td colspan="2">稀释比例为:30</td>
                    <td>1KG</td>
                    <td>34KG</td>
                    <td class="tab_btns" colspan="2">
                        <el-button class="edit_btn" type="primary" plain size="small" @click="editShow = true">编辑</el-button>
                        <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>
                    </td>
                </tr>
                <tr>
                    <td colspan="6" class="addBtn">
                        <el-button class="edit_btn" type="primary" plain size="small">添加肥料</el-button>
                    </td>
                </tr>
            </template>
            <template v-if="type == '栽培管理类'">
                <tr>
                    <td colspan="2">任务内容</td>
                    <td colspan="6">
                        <div class="video_box">
                            <span>观看视频:</span>
                            <div class="vdo-img">
                                <a href="javascript:;" class="vode-t" @click="videoClick" v-if="!videoShow">
                                    <img src="../../../../assets/images/image_1.png" />
                                </a>
                                <div class="vdo-play" v-else>
                                    <video id="v_player" src="../../../../assets/images/mp4.mp4" :controls="{'controls':videoShow}" :autoplay="videoShow"></video>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <WorkTaskSteps :isActiveNum="isActiveNum" :btnShow="false" @stepsClick="stepsClick"></WorkTaskSteps>
        <div class="bottom_btn">
            <el-button @click="releaseShow = true">发布</el-button>
        </div>
<!--        弹窗-->
<!--        删除-->
        <WxMessageBox :show="delShow" @save="delSave" @canse="delCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
<!--        添加/编辑农资-->
        <WxMessageBox :show="addShow" @save="addSave" @canse="addCanse">
            <div slot="content">
                <div class="import addTask">
                    <div class="item">
                        <span class="item_label">请选择农资种类:</span>
                        <div class="input">
                            <el-select v-model="types" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in typeOptions"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <span class="item_label">请选择农资名:</span>
                        <div class="input">
                            <el-select v-model="name" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in nameOptions"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <span class="item_label">稀释比例:</span>
                        <div class="input">
                            <el-input v-model="proportion" placeholder="请输入" size="mini"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
<!--        发布-->
        <WxMessageBox :show="releaseShow" @save="releaseSave" @canse="releaseCanse">
            <div slot="content">
                <div class="word">
                    <p>你是否确定发布此任务？</p>
                </div>
            </div>
        </WxMessageBox>
<!--        添加/编辑肥料-->
        <WxMessageBox :show="editShow" @save="editSave" @canse="editCanse">
            <div slot="content">
                <div class="import addTask">
                    <div class="item">
                        <span class="item_label">请选择肥料:</span>
                        <div class="input">
                            <el-select v-model="fertilizer" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in fertilizerOptions"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <span class="item_label">稀释比例:</span>
                        <div class="input">
                            <el-input v-model="ferProportion" placeholder="请输入" size="mini"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
    import WorkTaskSteps from '@/components/WorkTaskSteps';
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "release",
        data(){
            return{
                isActiveNum:0,
                timeEdit:false,
                time_val:'2021.04.15',
                explain:'',
                textareaShow:false,
                textareaSpanVal:'读取后台编写的操作说明，这里前台技术员可以更改。读取后台编写的操作说明，这里前台技术员可以更改。',
                // 巡园类，打药类，营养管理类，栽培管理类
                type:'巡园类',
                videoShow:false,
                delShow:false,
                addShow:false,
                types:'',
                typeOptions:[],
                name:'',
                nameOptions:[],
                proportion:'',
                releaseShow:false,
                editShow:false,
                fertilizer:'',
                fertilizerOptions:[],
                ferProportion:''
            }
        },
		created() {
			console.log(this.$route.params.id)
		},
        methods:{
            // 重新选择时间
            timeValChane(){
                this.timeEdit = false
            },
            // 保存
            saveTextareaSpanVal(){
                this.textareaSpanVal = this.explain
                this.textareaShow = false
                this.$nextTick(()=>{
                    this.$router.push({ name: 'workTask' });
                })
            },
            stepsClick(val){
                this.isActiveNum = val
            },
            videoClick(){
                this.videoShow = true
            },
            // 删除弹窗确认
            delSave(){
                this.delShow = false
            },
            // 删除弹窗取消
            delCanse(){
                this.delShow = false
            },
            // 添加/编辑农资弹窗确认
            addSave(){
                this.addShow = false
            },
            // 添加/编辑农资弹窗取消
            addCanse(){
                this.addShow = false
            },
            // 发布弹窗确认
            releaseSave(){
                this.releaseShow = false
            },
            // 发布弹窗取消
            releaseCanse(){
                this.releaseShow = false
            },
            // 添加/编辑肥料弹窗确认
            editSave(){
                this.editShow = false
            },
            // 添加/编辑肥料弹窗取消
            editCanse(){
                this.editShow = false
            },
        },
        components: {
            WorkTaskSteps,
            WxMessageBox
        }
    }
</script>

<style scoped lang="less">
    .release{
        .my_table{
            margin-top: 35px;
            .th_background{
                background-color: rgba(45, 153, 255, 0.3261);
            }
            .el-textarea__inner{
                text-align: left;
            }
            .tdBack1{
                background-color: rgba(246, 137, 255, 0.46);
            }
            .tdBack2{
                background-color: rgba(246, 137, 255, 0.18);
            }
            .time{
                .time_val{
                    padding-left: 18px;
                }
                .tab_btn{
                    font-size: 16px;
                    font-weight: 500;
                    color: #2D99FF;
                    cursor: pointer;
                    padding-left: 10px;
                }
            }
            .tab_btns{
                text-align: center;
                .el-button{
                    display: block;
                    margin: 0 auto;
                    &+.el-button{
                        margin-top: 15px;
                    }
                }
            }
            .addBtn{
                text-align: right;
                .el-button{
                    margin-right: 28px;
                }
            }
            .video_box{
                text-align: left;
                padding-left: 20px;
                .vdo-img{
                    width:500px;
                    font-size:0;
                    position:relative;
                    text-align: left;
                    margin-top: 15px;
                    .vode-t {
                        display:block;
                        width:100%;
                        position:relative;
                        z-index:2;
                        &:after {
                            content:"";
                            width:89px;
                            height:89px;
                            background:url('../../../../assets/images/ico-display.png') no-repeat;
                            background-size:cover;
                            position:absolute;
                            left:50%;
                            top:50%;
                            margin-left:-44.5px;
                            margin-top:-44.5px;
                        }
                    }
                    img {
                        width: 500px;
                        height: 280px;
                    }
                    video {
                        width:100%;
                        max-height:280px;
                    }
                    .vdo-play {
                        width: 500px;
                        position: relative;
                        left:0;
                        top:0;
                        z-index:1;
                    }
                }
            }
        }
        .bottom_btn{
            width: 100%;
            text-align: center;
            margin-top: 40px;
            .el-button{
                width: 310px;
                height: 48px;
                line-height: 48px;
                background: #2D99FF;
                font-size: 18px;
                color: #fff;
                padding: 0;
                border: 0;
                border-radius: 0;
            }
        }
    }
</style>
